// import { buildStars } from 'Functions/rating';
import { updateLazy } from "Functions/lazy";
import { scrollToEl } from "Functions/window";
import { initAnchors } from "Functions/anchor";
import { initWishlists } from "Common/wishlist";

import "Layouts/default";

import "Ui/shorten";
import "Ui/tabs";
import "Ui/toggle";
import "Components/modal/modal-remote";
import "Components/modal/modal-watchdog";
import { initCountdowns } from "Functions/countdown";

import "./catalog-jquery";
import { initSets } from "./catalog-sets";
import "./categories-filter";
import "./price-filter-babys";
import "./multiselect";
import "./filter-bubbles";
import { initTippy } from "Functions/tippy";
import { replaceTranslate } from "Functions/replaceTranslate";

const lang = document.querySelector("html").getAttribute("lang");
let localTexts = {};

const loadLocales = () => {
    return import(`Locale/${lang}.json`).then((module) => {
        localTexts = module.Catalog || {};
    });
};

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll(".pager__list .c-btn")) {
        if (pagerButton.classList.contains("is-active")) continue;

        pagerButton.addEventListener("click", (event) => {
            scrollToEl(
                document.querySelector(".c-listing-main__products"),
                parseInt(
                    getComputedStyle(document.documentElement).getPropertyValue("--header-height")
                )
            );
        });
    }
};

rEvent.on("Listing.fetchedData", () => {
    initSets();
    updateLazy();
    attachPaginatorEvents();
    initAnchors();
    initTippy();
    initTippy(".js-tippy-availability", {
        theme: "availability",
        maxWidth: "520px",
    });
    initWishlists();
});

document.addEventListener("DOMContentLoaded", function () {
    attachPaginatorEvents();
    initAnchors();
    initSets();
    initCountdowns();
});

document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("openFilter")) {
        
        customElements.whenDefined("r-toggle").then(() => {
            const filterWrapper = document.getElementById("filter-wrapper");
        
            requestAnimationFrame(() => {
                if (filterWrapper && filterWrapper.handleToggle) {
                    filterWrapper.handleToggle(true);
                }
            });
        });
    }
});

document.querySelector("#filter-wrapper").addEventListener("rToggle.afterOpen", (event) => {
    const trigger = event.detail.origEvent?.target?.closest("[r-toggle-trigger]");
    const target = event.target;

    if (trigger?.dataset?.tabId) {
        if (
            target.querySelector(
                `[r-tab-trigger][data-tab-id="filter-tab-${trigger.dataset.tabId}"]`
            )
        ) {
            target
                .querySelector(`[r-tab-trigger][data-tab-id="filter-tab-${trigger.dataset.tabId}"]`)
                .click();
        }
    }
});

const manufacturerFilterTriggers = document.querySelector(".js-manufacturer-filter-triggers");

if (manufacturerFilterTriggers) {
    manufacturerFilterTriggers
        .querySelectorAll(".js-trigger-manufacturer-filter")
        .forEach((trigger) => {
            trigger.addEventListener("click", (event) => {
                event.preventDefault();

                const id = trigger?.dataset?.id;

                document
                    .getElementById("filter[manufacturers][]")
                    .querySelector(`option[value="${id}"]`).selected = true;
                $(document.getElementById("filter[manufacturers][]")).change();
            });
        });
}

document.querySelector(".c-filter-sub").addEventListener("rTab.after.openTab", (event) => {
    updateLazy();
});
const enablerParam = 'recombee=';

const defaultGridFilter = enablerParam  + '&f=view%3Dgrid%7Cprice%5B%5D%3D1%2C376%7Csort%3Dpurchases%3Ad';
const hideElementIfUrlHasParams = (selector) => {
    const checkUrlParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const urlParamsString = urlParams.toString();
        const element = document.querySelector(selector);
        if (element) {
            if (urlParamsString && (urlParamsString !== defaultGridFilter && urlParamsString !== enablerParam)) {
                element.style.display = "none";
            } else {
                element.style.display = ""; // Reset to default
            }
        }
    };

    // Initial check on page load
    checkUrlParams();

    // Observe URL changes
    let lastUrl = window.location.href;
    const observer = new MutationObserver(() => {
        if (lastUrl !== window.location.href) {
            lastUrl = window.location.href;
            checkUrlParams();
        }
    });

    // Observe changes to the <body> element (attribute changes for SPA URL changes)
    observer.observe(document.body, { attributes: true, childList: true, subtree: true });
};

hideElementIfUrlHasParams(".c-listing-products__holder.is-recommended");


const toggleCategoryHeaderDescription = () => {
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get("page")) || 1;
    const desc = document.querySelector(".js-listing-description");
    const descMobile = document.querySelector(".js-listing-description-mobile");

    if (desc) desc.style.display = page > 1 ? "none" : "";
    if (descMobile) descMobile.style.display = page > 1 ? "none" : "";
};

const updateCategoryTitleinfo = () => {
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get("page")) || 1;
    const listingCount = document.querySelector(".js-listing-count");
    const categoryPageInfo = document.querySelector(".js-category-page-info");
    const pageCount = parseInt(document.querySelector('.js-catalog-seo-title')?.dataset.pageCount) || 1;
    const pageInfoText = localTexts.pageInfo || "Strana {0} z {1}";

    if (page > 1) {
        if (listingCount) listingCount.style.display = "none";
        if (categoryPageInfo) {
            categoryPageInfo.textContent = replaceTranslate(pageInfoText, page, pageCount);
            categoryPageInfo.classList.remove("is-hidden");
        }
    } else {
        if (listingCount) listingCount.style.display = "";
        if (categoryPageInfo) {
            categoryPageInfo.textContent = '';
            categoryPageInfo.classList.add("is-hidden");
        }
    }
};

const updateMetaTags = () => {
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get("page")) || 1;
    const categoryName = document.querySelector('.js-catalog-seo-title')?.dataset.categoryName || '';
    const pageCount = parseInt(document.querySelector('.js-catalog-seo-title')?.dataset.pageCount) || 1;
    const storeName = document.querySelector('.js-catalog-seo-title')?.dataset.storeName || '';
    const pageInfoText = localTexts.pageInfo || "Strana {0} z {1}";

    if (page > 1 && categoryName) {
        document.title = `${categoryName} - ${replaceTranslate(pageInfoText, page, pageCount)} | ${storeName}`;
    } else if (categoryName) {
        document.title = `${categoryName} | ${storeName}`;
    }
}


document.addEventListener("DOMContentLoaded", () => {
    loadLocales().then(() => {
        updateMetaTags();
        toggleCategoryHeaderDescription();
        updateCategoryTitleinfo();
    });
});
       
rEvent.on("Listing.fetchedData", () => {
    updateMetaTags();
    toggleCategoryHeaderDescription();
    updateCategoryTitleinfo();
});

